const RELOAD_KEY = 'chunk_reload_ts';
const COOLDOWN_MS = 30_000;

function canAutoReload(): boolean {
  const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
  return Date.now() - lastReload > COOLDOWN_MS;
}

function markReloadAttempt(): void {
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
}

export function reloadForStaleDeploy(force = false): void {
  if (!force && !canAutoReload()) return;

  markReloadAttempt();

  const url = new URL(window.location.href);
  url.searchParams.set('_deploy', String(Date.now()));
  window.location.replace(url.toString());
}

function stripDeployReloadParam(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('_deploy')) return;
  url.searchParams.delete('_deploy');
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
}

/** Runtime fallback for lazy chunk / preload failures after the app has mounted. */
export function registerDeployRecoveryListeners(): void {
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') return;

  stripDeployReloadParam();

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadForStaleDeploy();
  });
}
